const searchBar = document.querySelector(
  ".header__icons predictive-search #Search-In-Modal"
);
if (searchBar) {
  searchBar.addEventListener("click", () => {
    setTimeout(() => {
      let autoCompleteArrows = document.querySelectorAll(
        ".autocomplete-text-wrapper"
      );
      if (autoCompleteArrows) {
        autoCompleteArrows.forEach((arrow) => {
          if (arrow) {
            arrow.addEventListener("click", () => {
              searchBar.value =
                arrow.parentElement.getAttribute("data-searchterm");
              searchBar.focus();
              console.log(arrow.parentElement.getAttribute("data-searchterm"));
            });
          }
        });
      }
    }, 100);

    // let modalOverlay = document.querySelector(".modal-overlay");
    // modalOverlay.forEach((modal)=>{
    //   modal.addEventListener("click",()=>{
    //     let searchCloseButton =
    //   })
    // })
  });
}

function positionAutocompleteFixed() {
  const input = document.getElementById("Search-In-Modal");
  const autocomplete = document.querySelector(
    ".wizzy-autocomplete-wrapper.onLeft"
  );

  if (input && autocomplete) {
    const rect = input.getBoundingClientRect();

    autocomplete.style.top = `${rect.bottom}px`; // exactly below input
    autocomplete.style.left = `${rect.left}px`; // align with input
    autocomplete.style.width = `${rect.width}px`; // match width
  }
}

window.addEventListener("load", positionAutocompleteFixed);
window.addEventListener("resize", positionAutocompleteFixed);
window.addEventListener("scroll", positionAutocompleteFixed, true); // 'true' for capturing inside scrollable parents
document
  .getElementById("Search-In-Modal")
  .addEventListener("focus", positionAutocompleteFixed);
const observer = new MutationObserver(() => {
  const autocomplete = document.querySelector(
    ".wizzy-autocomplete-wrapper.onLeft"
  );
  if (autocomplete) {
    positionAutocompleteFixed();
  }
});

observer.observe(document.body, { childList: true, subtree: true });

function modifyPriceStructure(price) {
  price = price.toString().split(".")[0];

  return price;
}
let wizzyEvents = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      // if (window.matchMedia("(max-width: 768px)").matches) {
      //   window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
      //     dom: "details[open ='true'] predictive-search .search__input",
      //     type: "search",
      //   };
      // } else {
      //   window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
      //     dom: "details[open ='true'] predictive-search .search__input",
      //     type: "search",
      //   };
      // }
      // data.filters.configs.keepOpenedInMobileAfterApply = true;
      // window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
      //   desktop: 5000,
      //   mobile: 3000,
      // };
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      if (window.matchMedia("(max-width: 768px)").matches) {
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: "details[open ='true'] predictive-search .search__input",
          type: "search",
        };
      } else {
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: "details[open ='true'] predictive-search .search__input",
          type: "search",
        };
      }
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
        desktop: 5000,
        mobile: 3000,
      };
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      data.forEach((product) => {
        if (
          typeof product.price !== "undefined" &&
          product.price &&
          product.price.toString().includes(".")
        ) {
          product.price = product.price.toString().split(".")[0];
        }

        if (
          typeof product.sellingPrice !== "undefined" &&
          product.sellingPrice &&
          product.sellingPrice.toString().includes(".")
        ) {
          product.sellingPrice = product.sellingPrice.toString().split(".")[0];
        }

        if (product.mainImage === "https://via.placeholder.com/360x360") {
          product.mainImage = "";
        }
      });
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (data) {
      if (data.api == "search" || data.api == "filter") {
        if (typeof data.response.payload.facets !== "undefined") {
          var facets = data?.response?.payload?.facets;
          for (let index = 0; index < facets.length; index++) {
            const fElement = facets[index];
            if (fElement.key === "product_border_size_magento") {
              var fData = fElement.data;
              const customOrder = ["Small", "Medium", "Big", "Very Big"];

              fData.sort((a, b) => {
                return (
                  customOrder.indexOf(a.label) - customOrder.indexOf(b.label)
                );
              });

              data.response.payload.facets[index].data = fData;
            }
          }
        }
      }
      return data;
    }
  );

  // window.wizzyConfig.events.registerEvent(
  //   window.wizzyConfig.events.allowedEvents
  //     .BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
  //   function (data) {
  //     setTimeout(() => {
  //       const headItem = document.querySelector(
  //         '.autocomplete-item-head[data-index="0"]'
  //       );
  //       const headItem2 = document.querySelector(
  //         '.autocomplete-item-head[data-index="2"]'
  //       );
  //       if (headItem) {
  //         headItem.innerHTML = "Suggestions";
  //       }
  //       if (headItem2) {
  //         headItem2.innerHTML = "COLLECTIONS";
  //       }
  //     }, 0);
  //     return data;
  //   }
  // );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_WRAPPER_RENDER,
    function (data) {
      var searchInputs = document.getElementsByClassName("search__input");
      for (var i = 0; i < searchInputs.length; i++) {
        if (searchInputs[i].value) {
          data.query = searchInputs[i].value;
          console.log(searchInputs);
        }
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (payload) {
      console.log(payload);
      const labels = document.querySelectorAll(
        '[data-facetkey="sellingPrice"] .facet-item-label-value'
      );

      // Loop through each matching element and log its inner text value
      // labels.forEach((label) => {
      //   label.innerText = modifyPriceStructure(label.innerText);
      // });

      const minToolTip = document.querySelector(
        ".noUi-handle-lower .noUi-tooltip"
      );
      const maxToolTip = document.querySelector(
        ".noUi-handle-upper .noUi-tooltip"
      );
      const wizzyMinRange = document.querySelector(
        ".wizzy-range-wrapper .wizzy-min-range"
      );
      const wizzyMaxRange = document.querySelector(
        ".wizzy-range-wrapper .wizzy-max-range"
      );
      // tooltips.forEach((tooltip) => {

      console.log(
        modifyPriceStructure(minToolTip.textContent),
        modifyPriceStructure(maxToolTip.textContent)
      );
      minToolTip.textContent = modifyPriceStructure(minToolTip.textContent);
      maxToolTip.textContent = modifyPriceStructure(maxToolTip.textContent);
      wizzyMinRange.innerHTML = minToolTip.textContent;
      wizzyMaxRange.innerHTML = maxToolTip.textContent;

      // });
      const handleElement = document.querySelector(".noUi-handle");

      // Create a new MutationObserver instance
      const observer = new MutationObserver(function (mutationsList, observer) {
        for (let mutation of mutationsList) {
          // Check if the mutation is related to 'aria-valuemax' or 'aria-valuemin' attributes
          if (
            mutation.attributeName === "aria-valuemax" ||
            mutation.attributeName === "aria-valuemin"
          ) {
            // The 'aria-valuemax' or 'aria-valuemin' attribute has changed
            const minToolTip = document.querySelector(
              ".noUi-handle-lower .noUi-tooltip"
            );
            const maxToolTip = document.querySelector(
              ".noUi-handle-upper .noUi-tooltip"
            );
            const wizzyMinRange = document.querySelector(
              ".wizzy-range-wrapper .wizzy-min-range"
            );
            const wizzyMaxRange = document.querySelector(
              ".wizzy-range-wrapper .wizzy-max-range"
            );
            tooltips.forEach((tooltip) => {
              setTimeout(
                (tooltip) => {
                  minToolTip.textContent = modifyPriceStructure(
                    minToolTip.textContent
                  );
                  maxToolTip.textContent = modifyPriceStructure(
                    maxToolTip.textContent
                  );

                  wizzyMinRange.innerHTML = minToolTip.textContent;
                  wizzyMaxRange.innerHTML = maxToolTip.textContent;
                },
                100,
                tooltip
              );
            });
          }
        }
      });

      // Configure the observer to monitor attribute changes
      const observerConfig = { attributes: true };

      // Start observing the target element for attribute changes
      observer.observe(handleElement, observerConfig);
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER,
    function (data) {
      data.products.forEach((product) => {
        if (
          typeof product.price !== "undefined" &&
          product.price &&
          product.price.toString().includes(".")
        ) {
          product.price = product.price.toString().split(".")[0];
        }

        if (
          typeof product.sellingPrice !== "undefined" &&
          product.sellingPrice &&
          product.sellingPrice.toString().includes(".")
        ) {
          product.sellingPrice = product.sellingPrice.toString().split(".")[0];
        }
      });

      return data;
    }
  );
};

window.onWizzyLoaded.push(wizzyEvents);
